import styled from 'styled-components'

export const StyledCurrentTime = styled.div`  
    position: absolute;
    top: 66px;
    right: 5px;
    margin-top: -64px;
    font-weight: bold;
    font-size: 14px;
    color: #ffc26c;

` 



